/**
 * The possible manual mode override states from device model
 * These are the same as the possible values for the device's manual override setting
 */
export enum OPERATING_MODE {
    MANUAL_OPEN = "open",
    MANUAL_CLOSE = "closed",
    SCHEDULE = "none",
}

export enum OPERATING_MODE_TRANSITION_STATUS {
    IDLE = "idle",
    SENDING = "SENDING",
    CONFIRMING = "CONFIRMING",
    COMPLETE = "COMPLETE",
}
